import { render, staticRenderFns } from "./update-goods.vue?vue&type=template&id=30e8ea82&scoped=true"
import script from "./update-goods.vue?vue&type=script&lang=js"
export * from "./update-goods.vue?vue&type=script&lang=js"
import style0 from "./update-goods.vue?vue&type=style&index=0&id=30e8ea82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30e8ea82",
  null
  
)

export default component.exports